<div class="splash__layers">
  <span class="layer layer--aurora"></span>
  <div class="layer layer--stars" aria-hidden="true">
    <span
      *ngFor="let star of starField; trackBy: trackStar"
      class="star"
      [style.left.%]="(star.x + star.tileX) * 100"
      [style.top.%]="(star.y + star.tileY) * 100"
      [style.width.px]="star.size"
      [style.height.px]="star.size"
      [style.animation-delay.s]="star.delay"
      [style.opacity]="star.opacity"
    ></span>
  </div>
</div>
